import { SlotRepository } from '../Repositories/SlotRepository';
import { BatchUpdateSlotRequest, BatchUpdateSlotResponse } from '../../Model/Slot';
import { User } from '../../../User/Model/User';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';
import { canEditSlotDates } from '../../../../Utils/limitedPartnerAdmin';

export class BatchUpdateSlotUseCase {
  constructor(private repo: SlotRepository) {}
  
  execute(request: BatchUpdateSlotRequest, currentUser: User): Promise<BatchUpdateSlotResponse> {
    if (isSlotOperationRestricted(currentUser)) {
      throw new Error(getRestrictionMessage('수정', currentUser));
    }

    if (!request.slots.length) {
      return Promise.resolve({ updated_count: 0, updated_ids: [], errors: [] });
    }

    if (!canEditSlotDates(currentUser)) {
      request.slots.forEach(slot => {
        delete slot.start_date;
        delete slot.end_date;
      });
    }

    return this.repo.batchUpdate(request);
  }
}
